import Vue from 'vue'
import Router from 'vue-router'
import order from '@/components/order/marketing'
import marketing from '@/components/marketing/marketing'
import emergencyManage from '@/components/emergencyManage/emergencyManage'
import touristComplaint from '@/components/touristComplaint/main'
import nursingRoom from '@/components/nursingRoom/main'
import userStatistics from '@/components/userStatistics/main'
import finance from '@/components/finance/main'
import supplier from '@/components/supplier/main'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'marketing',
      component: marketing
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: marketing
    },{
      path: '/order',
      name: 'order',
      component: order
    },{
      name:'emergencyManage',
      path:'/emergencyManage',
      component:emergencyManage
    },{
      path: '/touristComplaint',
      name: 'touristComplaint',
      component: touristComplaint
    },{
      path: '/nursingRoom',
      name: 'nursingRoom',
      component: nursingRoom
    },{
      path: '/userStatistics',
      name: 'userStatistics',
      component: userStatistics
    },{
      path: '/finance',
      name: 'finance',
      component: finance
    },{
      path: '/supplier',
      name: 'supplier',
      component: supplier
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js